import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import messages from './local/index';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: 'pt-BR',
    fallbackLng: {
      default: ['pt-BR'],
      pt: ['pt-BR'],
      en: ['en-US'],
    },
    supportedLngs: ['pt-BR', 'en-US', 'pt', 'en'],
    load: 'languageOnly',
    debug: false,
    resources: messages,
    defaultNS: 'translation',
    ns: ['translation'],
    returnObjects: true,
    returnNull: false,
    returnEmptyString: false,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
